import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as FileUploadIcon } from '@/assets/img/file-upload-icon.svg';
import { ReactComponent as CatDefaultIcon } from '@/assets/img/pet-cat-default-icon.svg';
import { ReactComponent as DogDefaultIcon } from '@/assets/img/pet-dog-default-icon.svg';

import { Pet, Pets } from '../types';
import './MyPetDetailCard.scss';
import Lottie from 'lottie-react';
import progressAnimation from '@/assets/animation/loading.json';
import { showNotification } from '@/utils/notificationUtils';

type Props = {
  data: Pets;
  onChange: () => void;
};
export const PetDetailCard = ({ data }: Props) => {
  const [isUploading, setIsUploading] = useState(false);
  const [petProfilePic, setPetProfilePic] = useState<string>();
  useEffect(() => {
    if (data) {
      setPetProfilePic(data.petsImageUrl);
    }
  }, []);

  return (
    <div className="my-pet-detail-card">
      <div className="inner-section">
        <div className="pet-pic-uploader">
          <div className="image-section">
            {petProfilePic ? (
              <span className="image-holder">
                <img src={petProfilePic} />
              </span>
            ) : (data.petType && data.petType?.toLowerCase() === 'dog') || !data.petType ? (
              <DogDefaultIcon />
            ) : (
              <CatDefaultIcon />
            )}
          </div>
          <div className="detail-section">
            <p>{data.name}</p>
            <p className="desc">{data.notes}</p>
            <div className="breed-detail">
              <span title={data.breed}>
                Breed: <b>{data.breed}</b>
              </span>
            </div>
          </div>
        </div>
        <div className="breed-detail">
          <span>
            Breed: <b>{data.breed}</b>
          </span>
        </div>
      </div>
      <p className="desc">{data.notes}</p>
    </div>
  );
};
